/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
// @mui
import { Box, Button, Container, Divider, Grid, Pagination, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// layouts
import Layout from '../../layouts';
// components
import Page from '../../components/Page';

import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../components/Iconify';
import useLocales from '../../hooks/useLocales';
import useSettings from '../../hooks/useSettings';
import { getPlans, getSchools, getTopics, setTagSearch } from '../../redux/slices/hackerthon/hackerthon.tag';
import { TagItemStyle1, TagItemStyle2, TagItemStyle3 } from '../../sections/tag/TagItem';

// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
}));

// ----------------------------------------------------------------------

HomePage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function HomePage() {
  const router = useRouter();
  const { translate } = useLocales();
  const { themeStretch } = useSettings();

  const { type } = router.query;
  const title = type === 'school' ? translate('label.school') : type === 'plan' ? translate('label.plan') : translate('label.topic');

  return (
    <Page title={title} description={translate('explorer.description')} >
      <RootStyle >
        <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="h5">{title}</Typography>
                <Button onClick={router.back} startIcon={
                  <Iconify width={25} height={25} icon={'solar:arrow-left-broken'} />
                }><Typography variant="body2">{translate("button.goBack")}</Typography></Button>
              </Stack>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              {type === 'school' && <SchoolTags />}
              {type === 'plan' && <PlanTags />}
              {type === 'topic' && <TopicTags />}
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page >
  );
}

function SchoolTags() {
  const dispatch = useDispatch();
  const { schools, search, totalPages } = useSelector(state => state.hackerthonTag);

  useEffect(() => {
    dispatch(getSchools());
  }, [search]);

  //reset
  useEffect(() => () => { dispatch(setTagSearch({ ...search, page: 0, })); }, []);

  const handleChangePage = (_, page) => {
    dispatch(
      setTagSearch({
        ...search,
        page: page - 1,
      })
    );
  };

  return (
    <>
      <Grid container>
        {schools.map((tag, index) => (
          <Grid item xs={12} sm={6} md={3} key={tag.id}>
            <TagItemStyle1 tag={tag} index={index} />
          </Grid>
        ))}
      </Grid>
      <Stack alignItems={"center"} my={1.5}>
        <Pagination count={totalPages} variant='text' page={search.page + 1} onChange={handleChangePage} />
      </Stack>
    </>
  );
}

function PlanTags() {
  const dispatch = useDispatch();
  const { plans, search, totalPages } = useSelector(state => state.hackerthonTag);

  useEffect(() => {
    dispatch(getPlans());
  }, [search]);

  //reset
  useEffect(() => () => { dispatch(setTagSearch({ ...search, page: 0, })); }, []);

  const handleChangePage = (_, page) => {
    dispatch(
      setTagSearch({
        ...search,
        page: page - 1,
      })
    );
  };

  return (
    <>
      <Grid container>
        {plans.map((tag, index) => (
          <Grid item xs={12} sm={2} md={3} key={tag.id}>
            <TagItemStyle2 tag={tag} index={index} />
          </Grid>
        ))}
      </Grid>
      <Stack alignItems={"center"} my={1.5}>
        <Pagination count={totalPages} variant='text' page={search.page + 1} onChange={handleChangePage} />
      </Stack>
    </>
  );
}

function TopicTags() {
  const dispatch = useDispatch();
  const { topics, search, totalPages } = useSelector(state => state.hackerthonTag);

  useEffect(() => {
    dispatch(getTopics());
  }, [search]);

  //reset
  useEffect(() => () => { dispatch(setTagSearch({ ...search, page: 0, })); }, []);

  const handleChangePage = (_, page) => {
    dispatch(
      setTagSearch({
        ...search,
        page: page - 1,
      })
    );
  };

  return (
    <>
      <Box>
        {topics.map((tag, index) => (
          <TagItemStyle3 key={tag.id} tag={tag} index={index} />
        ))}
      </Box>
      <Stack alignItems={"center"} my={1.5}>
        <Pagination count={totalPages} variant='text' page={search.page + 1} onChange={handleChangePage} />
      </Stack>
    </>
  );
}